export const sectionStyles = {
  minH: ['lg', 'sm', 'xl'],
  w: 'full',
  mt: ['-104px', null, '-70px'],
  pb: [10, 8, 10],
  pt: ['144px', '96px', '104px'],
  color: 'white',
};
